module.exports = __webpack_public_path__ + "img/LP380.dbad3299.png";